import React, { Fragment, useEffect, useState } from "react";
import { Grid, CardContent, Typography, Box, Card, Container, Button, Skeleton, Tooltip } from "@mui/material";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SalesChart from "../../../services/SalesChart"
import DashboardModal from "./sections/DashboardModal";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Inventory2Outlined, InsertChartOutlined, MonetizationOnOutlined } from "@mui/icons-material";
import { getActivePermissionAccess } from "../../../services/moduleAccess";

const Dashboard = ({ updateUser, ...props }) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const headersSetCookie = window.localStorage.getItem("headersSetCookie");
  const [salesData, setSalesData] = useState({});
  const [showInfoAnalytics, setShowInfoAnalytics] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const currentUuid = window.localStorage.getItem("uuidSetCookie");
  const isAdmin = window.localStorage.getItem("isAdmin") === "true";
  const [preload, setPreload] = useState(true);
  const [isLoadingUser, setIsLoadingUser] = useState(false);
  const [enabledAccount, setEnabledAccount] = useState(false);
  const [enabledProducts, setEnabledProducts] = useState(false);
  const [enabledGuest, setEnabledGuest] = useState(false);

  const {
    resultsAnalyticsHighlights,
    errorAnalyticsHighlights,
    currentHotelUuid,
  } = props.analyticsReducer;

  useEffect(() => {
    if (window.localStorage.getItem("userData") !== undefined) {
      const idUser = JSON.parse(window.localStorage.getItem("userData")).id
      if (idUser) {
        let query = `${idUser}`;
        props.getUserPermissions(headersSetCookie, query, idUser);
        setIsLoadingUser(true);
      }
    }
  }, []);

  useEffect(() => {
    const userPermissions = props?.usersReducer?.resultsUserPermissions;
    if (isLoadingUser && userPermissions) {
      const is_superUser = userPermissions?.roles?.includes("ROLE_SUPERUSER");
      if (is_superUser) {
        setEnabledAccount(true)
        setEnabledProducts(true)
        setEnabledGuest(true)
      } else {
        setEnabledAccount(getActivePermissionAccess(userPermissions, "settings"))
        setEnabledProducts(getActivePermissionAccess(userPermissions, "products"))
        setEnabledGuest(getActivePermissionAccess(userPermissions, "guestDirectory"))
      }
      setIsLoadingUser(false);
      setPreload(false);
    }
  }, [props?.usersReducer?.resultsUserPermissions]);

  useEffect(() => {
    const firstLogin = window.localStorage.getItem('firstLogin');
    const parsedFirstLogin = firstLogin ? JSON.parse(firstLogin) : false;
    setOpenModal(parsedFirstLogin);

    if (currentHotelUuid !== currentUuid || !resultsAnalyticsHighlights) {
      props.resetSagaAnalyticsHighlights();
      setIsLoading(true);
      setShowInfoAnalytics(false);
      props.getSagaAnalyticsHighlights(headersSetCookie);
    } else {
      setSalesData(resultsAnalyticsHighlights);
      setShowInfoAnalytics(true);
      setIsLoading(false);
    }
  }, [currentUuid, headersSetCookie]);

  useEffect(() => {
    if (resultsAnalyticsHighlights !== null) {
      if (errorAnalyticsHighlights === true) {
        setSalesData({});
        setShowInfoAnalytics(false);
        setIsLoading(false);
      } else {
        setSalesData(resultsAnalyticsHighlights);
        setShowInfoAnalytics(true);
        setIsLoading(false);
      }
    }
  }, [resultsAnalyticsHighlights, errorAnalyticsHighlights]);

  const closeModal = () => {
    setOpenModal(false);
    window.localStorage.setItem('firstLogin', JSON.stringify(false));
    const form = { firstLogin: false };
    updateUser(headersSetCookie, form, JSON.parse(window.localStorage.getItem("userData")).id);
  };

  const handleClickAccount = () => {
    if (!isAdmin && currentUuid) {
      navigate(`/dashboard/account/show/${currentUuid}`);
    } else {
      navigate(`/dashboard/account/`);
    }
  };

  const handleClickBookings = () => {
    navigate('/dashboard/bookings')
  }

  const handleClickProduct = () => {
    navigate('/dashboard/products', { state: { redirectCreateIfEmpty: true } })
  };

  const handleClickGuestDirectory = () => {
    navigate('/dashboard/guestDirectory')
  };

  const handleClickReporting = () => {
    navigate('/dashboard/reports')
  };

  const HomeCard = ({ label, subtitle, buttonText, onClick, disabled = false }) => (
    <Card className="cardHome">
      <CardContent style={{ flex: 1 }}>
        <div className="sectionComponent">
          <div className="label">{label}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
      </CardContent>
      {disabled ? (
        <Tooltip
          title="Subscription or permission upgrade needed"
          placement="bottom"
          arrow
        >
          <span>
            <Button
              className="buttonCardHome"
              variant="contained"
              color="primary"
              onClick={onClick}
              disabled
              style={{ pointerEvents: "none" }}
            >
              {buttonText}
              <ArrowForwardIosIcon style={{ fontSize: '0.8rem', marginLeft: 10 }} />
            </Button>
          </span>
        </Tooltip>
      ) : (
        <Button
          className="buttonCardHome"
          variant="contained"
          color="primary"
          onClick={onClick}
        >
          {buttonText}
          <ArrowForwardIosIcon style={{ fontSize: '0.8rem', marginLeft: 10 }} />
        </Button>
      )}
    </Card>
  );

  const AnalyticsHighlightSection = ({ title, data, currency }) => {
    return (
      <Card
        className="tableList tableList_paper card-box cardTableContainer"
        component="section"
        elevation={4}
        style={{ borderRadius: 16, marginBottom: 32 }}
      >
        <CardContent className="Detail_Action_ViewContainer">
          <div className="sectionComponent">
            <div className="title">{title}</div>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8}>
              {Array.isArray(data.analytics) && data.analytics.length > 0 ? (
                <>
                  <Typography variant="subtitle1" style={{ marginBottom: '15px' }}>
                    Trailing {data.analytics.length} months
                  </Typography>
                  <SalesChart data={data.analytics} />
                </>
              ) : (
                <Box height={300} display="flex" justifyContent="center" alignItems="center" style={{ backgroundColor: '#f0f0f0', borderRadius: 8 }}>
                  <Container maxWidth="sm" className="mx-auto">
                    <Grid container direction="column" alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: "60vh", textAlign: "center" }}>
                      <Grid item>
                        <InsertChartOutlined color="primary" sx={{ fontSize: 56 }} />
                      </Grid>
                      <Grid item>
                        <Typography variant="h4" gutterBottom>Your insights start here.</Typography>
                        <Typography variant="body1" sx={{ maxWidth: "400px", mx: "auto" }}>
                          As soon as your products gain traction and sales begin, this section will visualize your growth over time.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Container>
                </Box>
              )}
            </Grid>

            <Grid item xs={12} sm={4}>
              {/* Card 1: Top-selling products */}
              <Card style={{ backgroundColor: '#cae4f9', marginBottom: '16px' }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">Top-selling experiences</Typography>
                    <Typography variant="body2" style={{ color: 'grey' }}>Last 7 days</Typography>
                  </Box>

                  {Array.isArray(data.booking_sales) && data.booking_sales.length > 0 ? (
                    <>
                      <Typography variant="h4" style={{ color: "#333333", margin: '5px 0' }}>
                        {data.booking_sales.slice(0, 3).reduce((acc, curr) => acc + (curr.count || 0), 0)}
                      </Typography>
                      <Box display="flex" flexDirection="column" gap={0.5}>
                        {data.booking_sales.slice(0, 3).map((item, index) => (
                          <Box key={index} display="flex" justifyContent="space-between">
                            <Typography variant="body2" style={{ color: "#333333" }}>
                              <b>{item.product_name || <i>(Unnamed)</i>}</b>
                            </Typography>
                            <Typography variant="body2" style={{ color: "#333333" }}>{item.count}</Typography>
                          </Box>
                        ))}
                      </Box>
                    </>
                  ) : (
                    <Box height={120} display="flex" justifyContent="center" alignItems="center" style={{ borderRadius: 8 }}>
                      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1} sx={{ textAlign: 'center' }}>
                        <Grid item>
                          <Inventory2Outlined color="primary" sx={{ fontSize: 40 }} />
                        </Grid>
                        <Grid item>
                          <Typography variant="subtitle2">No top-selling experience data yet.</Typography>
                          <Typography variant="body2" color="textSecondary">Start making sales to see experience performance.</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </CardContent>
              </Card>

              {/* Card 2: Revenue Collected */}
              <Card style={{ backgroundColor: '#cae4f9' }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">Estimated Revenue</Typography>
                    <Typography variant="body2" style={{ color: 'grey' }}>Last 7 days</Typography>
                  </Box>

                  {Array.isArray(data.booking_revenue) && data.booking_revenue.length > 0 ? (
                    <>
                      <Typography variant="h4" style={{ color: "#333333", margin: '5px 0' }}>
                        {currency} {data.booking_revenue
                          .slice(0, 3)
                          .reduce((acc, curr) => acc + (curr.revenue || 0), 0)
                          .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </Typography>
                      <Box display="flex" flexDirection="column" gap={0.5}>
                        {data.booking_revenue.slice(0, 3).map((item, index) => (
                          <Box key={index} display="flex" justifyContent="space-between">
                            <Typography variant="body2" style={{ color: "#333333" }}>
                              <b>{item.product_name || <i>(Unnamed)</i>}</b>
                            </Typography>
                            <Typography variant="body2" style={{ color: "#333333" }}>
                              {currency} {(item.revenue || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </>
                  ) : (
                    <Box height={120} display="flex" justifyContent="center" alignItems="center" style={{ borderRadius: 8 }}>
                      <Grid container direction="column" alignItems="center" justifyContent="center" spacing={1} sx={{ textAlign: 'center' }}>
                        <Grid item>
                          <MonetizationOnOutlined color="primary" sx={{ fontSize: 40 }} />
                        </Grid>
                        <Grid item>
                          <Typography variant="subtitle2">No revenue data to display.</Typography>
                          <Typography variant="body2" color="textSecondary">Revenue insights will appear once sales are made.</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  return (
    <Fragment>
      <DashboardModal
        open={openModal}
        onClose={closeModal}
      />

      <Container className="generalModuleCardContainer" style={{ padding: 15 }}>
        <Box>
          <Typography
            variant="h3"
            style={{
              fontWeight: 600,
              color: "#154153",
              fontSize: "1.8rem",
              textTransform: "uppercase",
              letterSpacing: "-0.5px"
            }}
          >
            Welcome to Travel Curious&nbsp;
            <span style={{ color: "#0077FF" }}>Activate</span>
          </Typography>

          <div className="sectionComponent">
            <div className="subtitle">
              Your gateway to Activating Your Brand, Elevating Your Customer
              Experience, and Driving Value through Loyalty and Ancillary Revenue
            </div>
          </div>
        </Box>


        {!preload ? (
          <Card
            className="tableList tableList_paper card-box cardTableContainer"
            component="section"
            elevation={4}
            style={{ marginBottom: 30, borderRadius: 16 }}
          >
            <CardContent className="Detail_Action_ViewContainer">
              <div className="sectionComponent">
                <div className="title">Let's Get Started</div>
              </div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <HomeCard
                    label="Finish setting up your account"
                    subtitle="Add contact info, bank details and other account information. Configure your Activate experience by adding account logos, colors and customizing your homepage."
                    buttonText="Account Configuration"
                    onClick={handleClickAccount}
                    disabled={!enabledAccount}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  {isAdmin ? (
                    <HomeCard
                      label="Review your bookings"
                      subtitle="Stay informed about all your upcoming reservations. Easily check booking details, monitor their current status, and follow any updates in real time."
                      buttonText="View Bookings"
                      onClick={handleClickBookings}
                    />
                  ) : (
                    <HomeCard
                      label="Create your first experience"
                      subtitle="Ready to build your experience? Simply follow the step-by-step guide to build your product, add details like descriptions and images, and set detailed pricing schedules."
                      buttonText="Experience Creation"
                      onClick={handleClickProduct}
                      disabled={!enabledProducts}
                    />

                  )}
                </Grid>

                <Grid item xs={12} sm={4}>
                  {isAdmin ? (
                    <HomeCard
                      label="Access detailed reporting"
                      subtitle="Review key metrics and performance insights to help you monitor activity, identify trends, and make informed decisions about your account."
                      buttonText="Access Reporting"
                      onClick={handleClickReporting}
                    />
                  ) : (
                    <HomeCard
                      label="Build your guest directory"
                      subtitle="Add dining options, spa information, concierge services and more, ensuring everything your guests need is just a click away."
                      buttonText="Guest Directory"
                      onClick={handleClickGuestDirectory}
                      disabled={!enabledGuest}
                    />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        ) : (
          <Card
            className="tableList tableList_paper card-box cardTableContainer"
            component="section"
            elevation={4}
            style={{ borderRadius: 16, padding: 16, marginBottom: 24 }}
          >
            <Skeleton variant="rectangular" height={300} />
          </Card>
        )}

        {isLoading || !salesData && (
          <Card
            className="tableList tableList_paper card-box cardTableContainer"
            component="section"
            elevation={4}
            style={{ borderRadius: 16, padding: 16 }}
          >
            <Skeleton variant="text" width="30%" height={40} style={{ marginBottom: 16 }} />
            <Skeleton variant="rectangular" height={300} style={{ marginBottom: 24 }} />
            <Skeleton variant="rectangular" height={180} style={{ marginBottom: 16 }} />
            <Skeleton variant="rectangular" height={180} />
          </Card>
        )}
        {!isLoading && showInfoAnalytics && salesData && (
          <>
            {isAdmin ? (
              <AnalyticsHighlightSection title="Bookings and revenue for your own experiences" data={salesData.internal} currency={salesData.currency} />
            ) : (
              <>
                <AnalyticsHighlightSection title="Bookings and revenue for your own experiences" data={salesData.internal} currency={salesData.currency} />
                <AnalyticsHighlightSection title="Bookings and revenue for third party experiences" data={salesData.external} currency={salesData.currency} />
              </>
            )}
          </>
        )}
      </Container>
    </Fragment >
  )
}

const mapStateToProps = (reducers) => {
  return reducers;
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (access, form, id) =>
      dispatch({ type: "UPDATE_USER", access, form, id }),
    getSagaAnalyticsHighlights: (access) => dispatch({ type: "GET_ANALYTICS_HIGHLIGHTS", access }),
    resetSagaAnalyticsHighlights: () => dispatch({ type: "RESET_ANALYTICS_HIGHLIGHTS" }),
    getUserPermissions: (access, query, idUser) => dispatch({ type: "GET_USER_PERMISSIONS", access, query, idUser }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
